// APP
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// UIKIT
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import 'uikit/dist/css/uikit.css'
import 'uikit/dist/js/uikit.js'
UIkit.use(Icons);

// VUIKIT
import Vuikit from 'vuikit'
import VuikitIcons from '@vuikit/icons'
import '@vuikit/theme'
Vue.use(Vuikit)
Vue.use(VuikitIcons)

// COOKIES HANDLER
let VueCookie = require('vue-cookie');
Vue.use(VueCookie);

// ANIMATIONS
import AOS from 'aos';
import 'aos/dist/aos.css';

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app');

AOS.init();
